import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar, SnackbarContent } from 'notistack';

import {
  Typography,
  Card,
  CardActions,
  IconButton,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

import { useStyles, VARIANT_STYLES } from './styles';

// Configurações do SnackMessage
export const OPTIONS = Object.freeze({
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  resumeHideDuration: 6000, // 6s
});

const SnackMessage = forwardRef((props, ref) => {
  const classes = useStyles();
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(props.id);
  }, [props.id, closeSnackbar]);

  return (
    <SnackbarContent
      ref={ref}
      className={classes.root}
    >
      <Card
        className={classes.card}
        style={{ backgroundColor: VARIANT_STYLES[props.variant] }}
      >
        <CardActions classes={{ root: classes.actionRoot }}>
          <Typography
            variant="subtitle2"
            className={classes.typography}
          >
            {props.message}
          </Typography>
          <div className={classes.icons}>
            <IconButton onClick={handleDismiss}>
              <CloseIcon />
            </IconButton>
          </div>
        </CardActions>
      </Card>
    </SnackbarContent>
  );
});

SnackMessage.propTypes = {
  id: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
};

export default SnackMessage;
